import type { AbTestKeys } from 'ab-test/constants/AbTestKeys'
import { useSetAbTestRequest } from 'ab-test/hooks/useSetAbTestRequest/useSetAbTestRequest'
import { useStateAbTest } from 'ab-test/hooks/useStateAbTest/useStateAbTest'
import type { FeatureFlagDecision } from 'ab-test/types'
import { getUserContext } from 'ab-test/utils/userContext'
import { useEffect, useState } from 'react'

import { handleDecision } from '../../utils/handleDecision'

interface UseAbTestProps {
	key: AbTestKeys
	attributes?: Record<string, unknown>
	defaultDecision?: Partial<FeatureFlagDecision>
}

const abTestsInitialized: AbTestKeys[] = []

export const useAbTest = ({
	key,
	attributes,
	defaultDecision,
}: UseAbTestProps) => {
	const { abTestReady, abRequested } = useStateAbTest()
	const setAbRequested = useSetAbTestRequest()

	const [abTest, setAbTest] = useState<FeatureFlagDecision | undefined>()

	useEffect(() => {
		if (!abRequested) {
			setAbRequested(true)
		}
	}, [])

	useEffect(() => {
		if (abTestReady) {
			const abTestActivated = abTestsInitialized.includes(key)
			const userContext = getUserContext()

			if (userContext) {
				const decision = handleDecision({
					userContext,
					key,
					abTestActivated,
					attributes,
				})
				if (!abTestActivated) {
					abTestsInitialized.push(key)
				}
				if (decision) {
					setAbTest(decision)
				}
			}
		}
	}, [abTestReady])

	return abTest
		? {
				enabled: abTest?.enabled,
				variables: abTest?.variables,
			}
		: defaultDecision
}
